import {
  ALGOLIA_API_KEY,
  ALGOLIA_APP_ID,
  ALGOLIA_INDEX_NAME,
  API_URL,
  BRANCH_KEY,
  CDN_URL,
  CRYPTO_IV_KEY,
  CRYPTO_KEY,
  ENV,
  FACEBOOK_APP_ID,
  FACEBOOK_PIXEL_ID,
  GRAPHQL_API_URL,
  GRAPHQL_CORE_URL,
  GTM_CONTAINER_KEY_BEEK,
  IMAGE_CDN_URL,
  ONELINK_URL,
  STRIPE_PUBLISHABLE_KEY,
  WEB_PLAYER_URL,
} from 'src/utils/env';

// The audiobook_id cookie should last for 1 week, unless refreshed
export const AUDIOBOOK_ID_COOKIE_MAX_AGE_DAYS = 7;
// The challenge_id cookie should last for 1 week, unless refreshed
export const CHALLENGE_ID_COOKIE_MAX_AGE_DAYS = 7;
// The user token cookie should last for 2 weeks, unless refreshed
export const TOKEN_COOKIE_MAX_AGE_DAYS = 14;

export default {
  algoliaApiKey: ALGOLIA_API_KEY,
  algoliaAppId: ALGOLIA_APP_ID,
  algoliaIndexName: ALGOLIA_INDEX_NAME,
  beekApiLogin: `${API_URL}/api/v1/login`,
  beekAuthLogin: `${API_URL}/v1/auth/login`,
  beekApiLoginToken: `${API_URL}/v1/login_token`,
  beekAuthLoginToken: `${API_URL}/v1/auth/login_token`,
  beekApiSignUp: `${API_URL}/api/v1/signup`,
  beekAuthSignUp: `${API_URL}/v1/auth/signup`,
  branchKey: BRANCH_KEY,
  cryptoIvKey: CRYPTO_IV_KEY,
  cryptoKey: CRYPTO_KEY,
  cdnUrl: CDN_URL,
  env: ENV,
  facebookAppId: FACEBOOK_APP_ID,
  facebookPixelId: FACEBOOK_PIXEL_ID,
  fallbackAvatar: '/design_system/user-icon.svg',
  fallbackAvatarUrl:
    'https://storage.googleapis.com/beek-profile-images/profile/images/Default-user-image.png',
  googleTagManagerId: GTM_CONTAINER_KEY_BEEK,
  graphqlUrl: GRAPHQL_CORE_URL,
  graphqlBeekApiWebUrl: GRAPHQL_API_URL,
  imageCdnUrl: IMAGE_CDN_URL,
  onelinkUrl: ONELINK_URL,
  stripePublishableKey: STRIPE_PUBLISHABLE_KEY,
  supportUrl: 'https://linktr.ee/holabeek',
  webPlayerUrl: WEB_PLAYER_URL,
  hotjarId: 3336413,
  hotjarSv: 6,
  routesExperiment: 'refactor_auth_routes_web',
  welcomeFlowFlagExperiment: 'welcome_flow_optimization_web',
  welcomeFlowFlagExperimentM2: 'welcome_flow_optimization_web_m2',
  unbounceFlagExperiment: 'unbounce_optimization_web',
  fallbackBeekLogo:
    'https://storage.googleapis.com/beek-web-cdn/design-system/images/favicons/faviconBeek-228.png',
  oneLinkAppOrWeb: 'https://beek.onelink.me/uzWC',
  oneLinkApp: 'https://link.beek.io/u4R8/rp0pr6a1',
  oneLinkWeb: 'https://link.beek.io/nq1r/hguultxw',
};
